/**
 * Pages that render a fixed bottom-0 mobile/tablet action bar (checkout's
 * "Place Order" bar, the quiz results "Continue"/shop bar, cart's "Proceed
 * to Checkout" bar) and therefore need extra bottom clearance so the bar
 * doesn't cover trailing content. Single source of truth for both the page
 * list and each bar's clearance size — read by both Footer (which supplies
 * the clearance normally) and Main (which supplies it instead when Footer
 * is hidden, e.g. in webview/app theme).
 */
export function getStickyBottomBarClearanceClass(
  pathname: string | null | undefined
): string | undefined {
  if (!pathname) return undefined;

  const isQuizResults = pathname.includes("/quiz/step/results");
  const isCheckoutPage = pathname === "/checkout/" || pathname === "/checkout";
  if (isQuizResults || isCheckoutPage) {
    return "pb-20 lg:pb-0";
  }

  const isCartPage = pathname === "/checkout/cart/" || pathname === "/checkout/cart";
  if (isCartPage) {
    return "pb-[250px] md:pb-0";
  }

  return undefined;
}
